import React, { useEffect, useState } from 'react';
import * as relatoriosApi from '../../api/relatorios';
import * as clientesApi from '../../api/clientes';
import { useExigeEmpresaEspecifica } from '../../hooks/useExigeEmpresaEspecifica';
import AvisoSelecioneEmpresa from '../../components/common/AvisoSelecioneEmpresa';
import PageHeader from '../../components/common/PageHeader';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import SearchableSelect from '../../components/common/SearchableSelect';
import { todayIso } from '../../utils/date';
import { STATUS_PEDIDO } from '../../utils/storeflowOpcoes';

export default function Relatorios() {
  const { bloqueado, carregandoEmpresas, semEmpresaCadastrada } = useExigeEmpresaEspecifica();
  const [clientes, setClientes] = useState([]);
  const [idCliente, setIdCliente] = useState('');
  const [status, setStatus] = useState('confirmado');
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState(todayIso());
  const [gerando, setGerando] = useState('');
  const [erro, setErro] = useState('');

  useEffect(() => {
    if (bloqueado) return;
    clientesApi
      .listClientes()
      .then((r) => setClientes(r.data))
      .catch(() => setErro('Erro ao carregar clientes.'));
  }, [bloqueado]);

  const exportar = async (formato) => {
    setErro('');
    setGerando(formato);
    try {
      const { data } = await relatoriosApi.exportPedidos(formato, {
        status: status || undefined,
        id_cliente: idCliente || undefined,
        data_inicio: dataInicio || undefined,
        data_fim: dataFim || undefined,
      });
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `relatorio_saidas.${formato}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setErro('Erro ao gerar relatório.');
    } finally {
      setGerando('');
    }
  };

  if (carregandoEmpresas) return <LoadingSpinner />;

  if (bloqueado) {
    return (
      <div>
        <PageHeader titulo="Relatórios" />
        <AvisoSelecioneEmpresa semEmpresaCadastrada={semEmpresaCadastrada} />
      </div>
    );
  }

  return (
    <div>
      <PageHeader titulo="Relatórios" subtitulo="Exportação de saídas para o financeiro" />

      {erro && (
        <div className="sf-login-alert mb-3">
          <i className="bi bi-exclamation-circle" />
          {erro}
        </div>
      )}

      <div className="sf-card p-4" style={{ maxWidth: 640 }}>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="sf-field-label">
              <span>Data inicial</span>
              <span className="sf-field">
                <i className="bi bi-calendar3" />
                <input type="date" value={dataInicio} onChange={(e) => setDataInicio(e.target.value)} />
              </span>
            </label>
          </div>
          <div className="col-md-6">
            <label className="sf-field-label">
              <span>Data final</span>
              <span className="sf-field">
                <i className="bi bi-calendar3" />
                <input type="date" value={dataFim} onChange={(e) => setDataFim(e.target.value)} />
              </span>
            </label>
          </div>
          <div className="col-md-6">
            <label className="sf-field-label">
              <span>Status do pedido</span>
              <select className="form-select" value={status} onChange={(e) => setStatus(e.target.value)}>
                <option value="">Todos</option>
                {STATUS_PEDIDO.map((s) => (
                  <option key={s.value} value={s.value}>{s.label}</option>
                ))}
              </select>
            </label>
          </div>
          <div className="col-md-6">
            <label className="sf-field-label">
              <span>Cliente</span>
              <SearchableSelect
                options={clientes.map((c) => ({ value: c.id_cliente, label: c.nome }))}
                value={idCliente}
                onChange={setIdCliente}
                placeholder="Todos os clientes"
              />
            </label>
          </div>
        </div>

        <div className="d-flex gap-2 mt-4">
          <button type="button" className="sf-btn sf-btn-primary flex-fill" disabled={gerando !== ''} onClick={() => exportar('xlsx')}>
            <i className="bi bi-file-earmark-spreadsheet" />
            {gerando === 'xlsx' ? 'Gerando...' : 'Exportar XLSX'}
          </button>
          <button type="button" className="sf-btn sf-btn-ghost flex-fill" disabled={gerando !== ''} onClick={() => exportar('pdf')}>
            <i className="bi bi-file-earmark-pdf" />
            {gerando === 'pdf' ? 'Gerando...' : 'Exportar PDF'}
          </button>
        </div>
      </div>
    </div>
  );
}
